import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CatalogRepositoryService } from '../../services/catalog-repository.service';
import {
  AttributeNode,
  GetCatalogCategoryAttributesResponse as Attribute,
} from '@medindex-webapi';
import { RouterLink } from '@angular/router';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { ButtonResetFiltersComponent } from '../button-reset-filters/button-reset-filters.component';
import { take } from 'rxjs';
import { tap } from 'rxjs/operators';
import { YmGoalCatalog } from '../../enums/ym-goal-catalog.enum';
import { YmService } from '@shared/services/yandex-metrica/ym.service';

@Component({
  selector: 'app-catalog-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterLink, AsyncPipe, NgForOf, NgIf, ButtonResetFiltersComponent],
})
export class FiltersComponent {
  constructor(
    public repository: CatalogRepositoryService,
    private ymService: YmService
  ) {}

  @Input() attributes: Attribute[] | undefined;

  toggleAttribute(id: number): void {
    this.ymService.reachGoal(YmGoalCatalog.FilterChanged);
    this.setAttributesToUrl(id);
  }

  private setAttributesToUrl(id: number): void {
    this.repository.selectedAttributes$
      .pipe(
        take(1),
        tap((attributes: number[]): void => {
          let selectedAttributes: number[] = attributes;

          const isSelected: boolean = selectedAttributes.includes(id);

          if (isSelected) {
            selectedAttributes = selectedAttributes.filter(
              (item: number): boolean => item != id
            );
          } else {
            selectedAttributes.push(id);
          }

          this.repository.setQueryParamsUrl({
            attributes: selectedAttributes.length
              ? selectedAttributes.toString()
              : null,
          });
        })
      )
      .subscribe();
  }

  trackByAttributeId(index: number, attribute: AttributeNode): number {
    return attribute.id;
  }
}
